import classNames from "classnames";
import permissionDeniedToast from "utils/permissionDeniedToast";

import "./EmaButton.sass";

const EmaButton = ({
  onClick,
  btnDark,
  tooltip,
  icon,
  reversed,
  title,
  disabled,
  bg,
  sm,
  xs,
  block,
  img,
  className,
  targetActionDenied,
}) => {
  const mainContent = () => (
    <>
      {reversed && title && <span>{title}</span>}
      {icon && <i className={`icon ${icon}`}></i>}
      {!reversed && title && <span>{title}</span>}
    </>
  );
  return (
    <>
      <button
        data-tooltip-id="message-tooltip"
        data-tooltip-content={
          targetActionDenied
            ? "You are not permitted to perfom this action."
            : tooltip
        }
        className={classNames("ema-btn", className, {
          "btn-ema-dark": btnDark && !targetActionDenied,
          "btn-disabled": targetActionDenied,
          disabled: disabled,
          xs: xs,
          sm: sm,
          bg: bg,
          block: block,
          img: img,
        })}
        onClick={
          disabled
            ? () => {}
            : targetActionDenied
            ? permissionDeniedToast
            : onClick
        }
      >
        {mainContent()}
      </button>
    </>
  );
};

export default EmaButton;
